import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';

// marvin-core authenticates on X-Authorization-Key alone —
// ApiKeyAuthenticationFilter reads that header and nothing else, and
// "Authorization" only ever appeared in the CORS allow-list. The Bearer JWT
// this used to sign was never inspected, so signing it in the browser bought
// nothing and kept jsonwebtoken (and its advisories) in the bundle.
const httpLink = new HttpLink({
  uri: process.env.VUE_APP_GRAPHQL_HTTP,
  headers: {
    'X-Authorization-Key': process.env.VUE_APP_MARVIN_API_KEY
  }
});

export const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache({
    addTypename: false
  }),
  connectToDevTools: process.env.VUE_APP_APOLLO_DEV_TOOLS_ENABLED == 'true'
});

// Stores consume `apolloProvider.defaultClient`; vue-apollo itself is gone
// (no live component used $apollo), so this keeps the import surface intact.
export default { defaultClient: apolloClient };
